import type { RegisterProps } from "../data-types";

import type { ChangeEvent } from "react";

type Props = {
  className?: string;
  checked?: boolean;
  disabled?: boolean;
  hasErrors?: boolean;
  onChange?: (e: ChangeEvent<HTMLInputElement>) => void;
  value: string;
  registerProps: RegisterProps;
};

export default function InputRadio({
  className = "",
  disabled = false,
  checked,
  onChange,
  value,
  registerProps,
  ...rest
}: Props) {
  return (
    <input
      className={`kup-radio ${className}`}
      checked={checked}
      disabled={disabled}
      id={`${registerProps["name"]}-${value}`}
      type="radio"
      value={value}
      {...registerProps}
      {...rest}
      onChange={(e) => {
        registerProps.onChange(e); // let react-hook-form handle it first
        onChange?.(e);             // then call the custom handler
      }}
    />
  );
}
